import style from './workout-trainer-info.module.scss'
import { SessionContext } from '../../context/session-context'
import { useTrainerModalContext } from '../../context/trainer-modal-context'
import { Trainer } from '../../dao/core-dao'
import { ImagePublicFileId } from '../image/image-public-file-id'
import { ChevronSvgIcon } from '../util/images'
import React, { useContext, useEffect } from 'react'
import { Col, Row } from 'react-bootstrap'

export const WorkoutTrainerInfo = (props: { trainerId: string }): React.ReactElement => {
  const { trainerId } = props
  const [trainer, setTrainer] = React.useState<Trainer | undefined>()
  const { trainerById } = useContext(SessionContext)
  const { openTrainer } = useTrainerModalContext()

  useEffect(() => {
    setTrainer(trainerById(trainerId))
  }, [trainerId, trainerById])

  if (!trainer) {
    return <div>Loading...</div>
  }
  return (
    <Row className={style.container}>
      <Col xs={'auto'}>
        <ImagePublicFileId fileId={trainer?.mediumProfilePhotoPublicFileId} roundedCircle className={style.avatar} />
      </Col>
      <Col className={`${style.actions} pl-0`}>
        <Row>
          <Col className={style.trainerName}>
            {trainer.firstName} {trainer.lastName}
          </Col>
        </Row>
        <Row>
          <Col>
            <button
              type="button"
              onClick={() => openTrainer(trainerId, trainer)}
              className={`flex align-items-center border-0 bg-transparent p-0 text-start ${style.trainerProfileLink}`}
            >
              View trainer profile <ChevronSvgIcon className="ml-2 mt-1" />
            </button>
          </Col>
        </Row>
      </Col>
    </Row>
  )
}
